import {Tooltip} from '@mantine/core';
import React from 'react';

import {ZIndexRole} from 'styles/StyleConstants';
import HelpIcon from 'ui-library/icons/HelpIcon';

interface Props {
  text: string;
  className?: string;
}

export default function HelpToolTip({className, text}: Props): JSX.Element {
  return (
    <Tooltip
      events={{focus: true, hover: true, touch: true}}
      label={text}
      withinPortal={true}
      zIndex={ZIndexRole.TOOLTIP}
    >
      <HelpIcon className={className} />
    </Tooltip>
  );
}
